// extracted by mini-css-extract-plugin
export var actionBtn = "pages-eula-__EulaById-module___actionBtn";
export var actionFooter = "pages-eula-__EulaById-module___actionFooter";
export var actionHeading = "pages-eula-__EulaById-module___actionHeading";
export var decline = "pages-eula-__EulaById-module___decline";
export var declineToS = "pages-eula-__EulaById-module___declineToS";
export var tosBody = "pages-eula-__EulaById-module___tosBody";
export var tosHeader = "pages-eula-__EulaById-module___tosHeader";
export var tosIntro = "pages-eula-__EulaById-module___tosIntro";